import { mode } from '@chakra-ui/theme-tools';

const baseStyle = props => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 3,
    width: '100%',
    flexWrap: 'nowrap',
  },
  fieldWrapper: {
    position: 'relative',
    flex: '0 0 150px',
    width: '150px',
    minWidth: '150px',
    fontWeight: 'extrabold',
  },
  field: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    minH: '48px',
    px: 0,
    py: 1,
    bg: 'transparent',
    border: 'none',
    color: mode('graphite.500', 'dark.300')(props),
    fontSize: '20px',
    lineHeight: '1.2',
    textAlign: 'left',
    cursor: 'pointer',
    _hover: {
      opacity: 0.85,
    },
    _focusVisible: {
      outline: 'none',
    },
    fontWeight: 'bold',
  },
  fieldLabel: {
    flex: '1',
    minW: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  clearButton: {
    flexShrink: 0,
  },
  icon: {
    flexShrink: 0,
  },
  dropdown: {
    position: 'absolute',
    top: 'calc(100% - 1px)',
    zIndex: 'dropdown',
    bg: mode('white.100', 'dark.100')(props),
    color: mode('graphite.500', 'dark.300')(props),
    borderWidth: '1px',
    borderColor: '#E2E8F0',
    borderRadius: 'md',
    boxShadow: 'lg',
    p: 2,
    width: 'max-content',
    minWidth: '320px',
    maxWidth: 'calc(100vw - 32px)',
    left: props.side === 'left' ? 'auto' : 0,
    right: props.side === 'left' ? 0 : 'auto',
  },
  options: {
    maxH: '35ch',
    overflowY: 'auto',
  },
  option: {
    w: '100%',
    alignItems: 'center',
    gap: 2,
    px: 1,
    py: 2,
    textAlign: 'left',
    borderRadius: 'sm',
    cursor: 'pointer',
  },
  checkbox: {
    mt: '2px',
    pointerEvents: 'none',
    border: 'none',
  },
  optionText: {
    fontSize: '12px',
    fontWeight: 'semibold',
    lineHeight: '1.2',
  },
  optionInfo: {
    mt: '4px',
    fontSize: '10px',
    lineHeight: '1.2',
    fontWeight: 'normal',
    color: mode('graphite.400', 'dark.400')(props),
    whiteSpace: 'pre-line',
  },
  tags: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 2,
    pt: '2px',
    minW: 0,
    flex: '1 1 auto',
  },
  tag: {
    borderRadius: 'full',
    px: 3,
    py: 2,
    cursor: 'pointer',
    userSelect: 'none',
  },
});

const sizes = {
  sm: {
    field: {
      fontSize: '16px',
      flex: '0 0 100px',
      width: '100px',
      minWidth: '100px',
    },
    fieldWrapper: {
      flex: '0 0 100px',
      width: '100px',
      minWidth: '100px',
    },
    dropdown: {
      minWidth: '170px',
    },
    optionText: {
      fontSize: '11px',
    },
    optionInfo: {
      fontSize: '9px',
    },
  },
  md: {
    field: {
      fontSize: '20px',
      flex: '0 0 120px',
      width: '120px',
      minWidth: '120px',
    },
    fieldWrapper: {
      flex: '0 0 120px',
      width: '120px',
      minWidth: '120px',
    },
    dropdown: {
      minWidth: '200px',
    },
  },
};

const variants = {
  outline: props => ({
    field: {
      color: mode('graphite.500', 'dark.300')(props),
    },
  }),
  flushed: props => ({
    field: {
      color: mode('graphite.500', 'dark.300')(props),
    },
  }),
  blueLight: props => ({
    field: {
      fontWeight: 'semibold',
      color: mode('graphite.500', 'dark.300')(props),
    },
    dropdown: {
      bg: 'white.100',
    },
  }),
};

const defaultProps = {
  size: 'md',
  variant: 'outline',
  side: 'right',
};

export default {
  parts: [
    'wrapper',
    'fieldWrapper',
    'field',
    'fieldLabel',
    'clearButton',
    'icon',
    'dropdown',
    'options',
    'option',
    'checkbox',
    'optionText',
    'optionInfo',
    'tags',
    'tag',
  ],
  baseStyle,
  sizes,
  variants,
  defaultProps,
};
